import { useMutation } from '@tanstack/react-query';
import {
  NotificationMessage,
  NotificationsQueue,
} from '@/components/Notifications';
import { Endpoint } from '@/constants';

const postFormData = async (payload: Record<string, unknown>) => {
  const response = await fetch(Endpoint.Notify, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams(
      Object.entries(payload).map(([k, v]) => [k, String(v ?? '')]),
    ),
  });

  if (!response.ok && response.status !== 429) {
    throw new Error(`Response status: ${response.status}`);
  }

  return response.json();
};

export const useNotifyMe = () => {
  const { isPending, mutate } = useMutation({
    mutationFn: postFormData,
    onSuccess: data => {
      NotificationsQueue.add(
        {
          notification: (
            <NotificationMessage $isError={!data.isSuccess}>
              {data.messages[0]}
            </NotificationMessage>
          ),
        },
        { timeout: 5000 },
      );
    },
  });

  return { isPending, notify: mutate };
};
